import { APIClient } from '../helpers/api_helper';
const AxiosClient = new APIClient()

const fetchPOListForPI = () => AxiosClient.get('/fetch-po-list-to-pi');
const addPiHistory = payload => AxiosClient.post('/create-pi', payload)
const fetchPIList = ()=> AxiosClient.get('/fetch-pi-history');
export {
    fetchPOListForPI,
    addPiHistory,
    fetchPIList
  }